import { render, staticRenderFns } from "./multiple-items.vue?vue&type=template&id=13b6e1d5&scoped=true&"
import script from "./multiple-items.vue?vue&type=script&lang=js&"
export * from "./multiple-items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b6e1d5",
  null
  
)

export default component.exports